import { tscope } from '@i18n';
import { removeNilValues } from '@lib/Object';
import Validator from '@lib/Validator';

export const ts = tscope('Requisition.documents.addressFormModal');

export const resolver = (values) => {
  const {
    street,
    extNumber,
    intNumber,
    zip,
    neighborhood,
    municipality,
    stateName,
  } = values;

  const errors = {
    street: Validator(street).required().result(),
    extNumber: Validator(extNumber).required().result(),
    intNumber: Validator(intNumber).result(),
    zip: Validator(zip).required().zipCode().result(),
    neighborhood: Validator(neighborhood).required().result(),
    municipality: Validator(municipality).required().result(),
    stateName: Validator(stateName).required().result(),
  };
  return { values, errors: removeNilValues(errors) };
};
